import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../context/Context";
import toast from "react-hot-toast";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { auth, fireDB } from "../../firebase/FirebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import Loader from '../../components/Loader/Loader'
import './Login.css';


function Signup() {
  const context = useContext(MyContext);
  const { loading, setLoading } = context;

  // navigate 
  const navigate = useNavigate();

  // User Signup State 
  const [userSignup, setUserSignup] = useState({
    name: "",
    email: "",
    password: "",
    role: "user"
  });

  const userSignupFunction = async (e) => {
    e.preventDefault();
      // validate using regex 
      let emailRegex = /^[A-Za-z]+[\d]+[@]+[gmail]+[.]com$/.test(userSignup.email);
  
    if (userSignup.name === "" || userSignup.email === "" || userSignup.password === "") {
      toast.error("All Fields are required")

    } else if (userSignup.name.length < 3) {
      toast.error("Name required minimum 3 char")
    } else if (userSignup.email.length < 14 || !emailRegex ) {
      toast.error("enter valid email or use @gmail.com")
    }
    else if (userSignup.password.length < 6) {
      toast.error("Password required minimum 6 char")
    }

    setLoading(true);
    try {
      const users = await createUserWithEmailAndPassword(auth, userSignup.email, userSignup.password);

      // create user object
      const user = {
        name: userSignup.name,
        email: users.user.email,
        uid: users.user.uid,
        role: userSignup.role,
        time: Timestamp.now(),
        date: new Date().toLocaleString(
          "en-US",
          {
            month: "short",
            day: "2-digit",
            year: "numeric",
          }
        )
      }

      // create user Refrence
      const userRefrence = collection(fireDB, "user")

      // Add User Detail
      addDoc(userRefrence, user);

      setUserSignup({
        name: "",
        email: "",
        password: ""
      })

      toast.success("Signup Successfully");

      setLoading(false);
      navigate('/login');

    } catch (error) {
      console.log(error);
      setLoading(false);
    }

  }

return (
  <div className="min-h-screen bg-[#fdf7f7] flex items-center justify-center px-6">
    {loading && <Loader />}

    <div className="max-w-6xl w-full grid md:grid-cols-2 gap-12 items-center">
      {/* 🔹 Left Image Section */}
      <div className="hidden md:flex justify-center">
        <img
          src="https://i.pinimg.com/736x/b1/4b/67/b14b67a298e73ea8bc2318404492b3ba.jpg"
          alt="Wedding Illustration"
          className="rounded-2xl shadow-lg w-[60%]"
        />
      </div>

      {/* 🔹 Right Form Section */}
      <div>
        <h2 className="text-4xl font-serif text-gray-800 mb-4">Register</h2>
        <p className="text-gray-500 mb-8">
          Make your wedding a memorable event with us
        </p>

        <form className="space-y-6">
          {/* Name */}
          <div>
            <label className="block text-lg font-quicksand text-gray-700 mb-2">Name*</label>
            <input
              type="text"
              value={userSignup.name}
              onChange={(e) =>
                setUserSignup({ ...userSignup, name: e.target.value })
              }
              placeholder="John Doe"
              className="w-full rounded-full border border-gray-300 px-5 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-lg font-quicksand text-gray-700 mb-2">Email*</label>
            <input
              type="email"
              value={userSignup.email}
              onChange={(e) =>
                setUserSignup({ ...userSignup, email: e.target.value })
              }
              placeholder="mail@website.com"
              className="w-full rounded-full border border-gray-300 px-5 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none"
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-lg font-quicksand text-gray-700 mb-2">
              Password*
            </label>
            <input
              type="password"
              value={userSignup.password}
              onChange={(e) =>
                setUserSignup({ ...userSignup, password: e.target.value })
              }
              placeholder="Min. 8 characters"
              className="w-full rounded-full border border-gray-300 px-5 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none"
            />
          </div>

          {/* Button */}
          <button
            onClick={userSignupFunction}
            className="w-full font-quicksand bg-[#b76d68] hover:bg-red-700 text-white py-3 rounded-md font-medium transition duration-300"
          >
            Create Account
          </button>

          <p className="text-center text-sm text-gray-600 mt-4">
            Already have an account?{" "}
            <Link
              to="/login"
              className="text-[#b76d68] font-medium hover:underline"
            >
              Sign In
            </Link>
          </p>
        </form>
      </div>
    </div>
  </div>
);

}

export default Signup